export const icon = (id) => {
  const icons = {
    6046: "mdi-soccer",
    54094: "mdi-tennis-ball",
    154919: "mdi-boxing-glove",
    48242: "mdi-basketball",
    154914: "mdi-baseball",
    154830: "mdi-volleyball",
    10: "mdi-trophy-award",
    687890: "mdi-gamepad-variant-outline",
    131506: "mdi-football",
    35709: "mdi-handball", // Handebol
    265917: "mdi-table-tennis", // Tênis de mesa
    621569: "mdi-volleyball", // Vôlei de praia
    51: "mdi-trophy", // Vôlei de praia
    52: "mdi-sword-cross", //Um pra um
    687887: "mdi-shoe-sneaker", //Futsal
    54: "mdi-trophy-award",
    53: {
      custom: true,
      src: "futvolei.png",
    }, // Futvolei
  };
  return icons[id];
};
